<!---================== TITLE FLOW MONITORING HOE ==================--->
<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Estatus HOE</h1>
</div>

<!---================== SECTION FOR BUTTONS ==================--->
<!--&================== TITLE LIBRARY ==================&-->
<div class="divider-butons-FM">

  <!--^====== BUTTON FOR FILTER HOE FOR DATE EXPIRED ======^-->
  <div routerLink="/Dashboard/CCP/SeeDExpirationCCP" class="btn btn-icon-text-left">
    <span class="text">Estatus vencimiento</span><i
      class="fa-regular fa-circle-question"></i>
  </div>

  <!--^====== BUTTON FOR OPEN OR CLOSE MODAL HELP ======^-->
  <div (click)="ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </div>
</div>

<!---================== SECTION FOR TABLE ==================--->
<div class="container-global-components ConFM">


  <!--^====== SECTION FOR TABLE ======^-->
  <div class="Table-FM Table-container-Global">

    <p-table #dtFMCCP [value]="ALL_FLOWM_CCP" [(selection)]="SelectedALL_FLOWM_CCP" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Name','Revision_No','Model_Year','Code','Invoice_4M','Reviewer_Name','Approver_Name']">


      <!---================= SEARCH AND ALL HOE =================--->
      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR HOE SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_FlowM" type="text"
                (input)="dtFMCCP.filterGlobal(Filter_FlowM, 'contains')" placeholder="Buscar en estatus HOE..." />
            </div>
          </div>
          <div class="right-CT">

            <!--?===== INFO OF TOTAL HOE =====?-->
            <div class="AllFiles">Total de HOE contribuidas:
              <b>{{ALL_FLOWM_CCP.length}}</b><i class="fas fa-file"></i>
            </div>
          </div>
        </div>

      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let Header of HeadersFM">

            <ng-container *ngIf="Header.Key_Header==='ROU'">
              <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAM'">
              <th pSortableColumn="Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOR'">
              <th pSortableColumn="Revision_No" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter type="text" field="Revision_No" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='MOY'">
              <th pSortableColumn="Model_Year" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Model_Year"></p-sortIcon>
                    <p-columnFilter field="Model_Year" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Modelo</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Model_Year"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>


                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='COD'">
              <th pSortableColumn="Code" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Code"></p-sortIcon>
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              <th pSortableColumn="Invoice_4M" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Invoice_4M"></p-sortIcon>
                    <p-columnFilter type="text" field="Invoice_4M" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REV'">
              <th pSortableColumn="Reviewer_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Reviewer_Name"></p-sortIcon>
                    <p-columnFilter field="Reviewer_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre revisor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Reviewer_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APP'">
              <th pSortableColumn="Approver_Name" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Approver_Name"></p-sortIcon>
                    <p-columnFilter field="Approver_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre aprobador</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver_Name"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAC'">
              <th pSortableColumn="Date_Created" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Created"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAE'">
              <th pSortableColumn="Date_Expiration" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Expiration"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Expiration" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='STA'">
              <th pSortableColumn="Status" class="{{Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Status" placeholder="Seleccione"
                          (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option">
                                    <div *ngSwitchCase='1'>Aprobada</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazada</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>


          </ng-container>

        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-ALL_FLOWM_CCP>
        <tr>
          <td *ngFor="let Header of HeadersFM">


            <ng-container *ngIf="Header.Key_Header==='ROU'">
              <div (click)="SeeCCPLibrary(ALL_FLOWM_CCP.Path)" class="Btn-Ubication btn-icon-text-left">
                <span class="text">Ubicación HOE</span><i class="fa-solid fa-location-arrow"></i>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NAM'">
              {{ALL_FLOWM_CCP.Name}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='NOR'">
              {{ALL_FLOWM_CCP.Revision_No}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='MOY'">
              {{ALL_FLOWM_CCP.Model_Year===0?'N/A':ALL_FLOWM_CCP.Model_Year}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='COD'">
              {{ALL_FLOWM_CCP.Code}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='INV'">
              {{ALL_FLOWM_CCP.Invoice_4M}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='REV'">
              <div (click)="SeeReason_Reviewer(ALL_FLOWM_CCP)" class="Status-Task">
                <div class="Icon-Status Status{{ALL_FLOWM_CCP.StatusTaskReviewer}}">
                  <div><i class="fa-solid {{Icons[ALL_FLOWM_CCP.StatusTaskReviewer-1].Icon}}"></i></div>
                </div>
                <span class="Name"> {{ALL_FLOWM_CCP.Reviewer_Name}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='APP'">

              <div (click)="SeeReason_Approver(ALL_FLOWM_CCP)" class="Status-Task">
                <div class="Icon-Status Status{{ALL_FLOWM_CCP.StatusTaskApprover}}">
                  <div><i class="fa-solid {{Icons[ALL_FLOWM_CCP.StatusTaskApprover-1].Icon}}"></i></div>
                </div>
                <span class="Name"> {{ALL_FLOWM_CCP.Approver_Name}}</span>
              </div>

            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAC'">
              {{DateFormat(ALL_FLOWM_CCP.Date_Created)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='DAE'">
              <div class="Container-Expired">{{DateFormat(ALL_FLOWM_CCP.Date_Expiration)}}
                <div class="Date-Expired {{Expiry_Status(ALL_FLOWM_CCP.Date_Expiration)}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header==='STA'">
              <div class="ContainerStatus">
                <div class="StatusTool S{{ALL_FLOWM_CCP.Status}}"></div>{{Status_string(ALL_FLOWM_CCP.Status)}}
              </div>
            </ng-container>


          </td>

        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="ALL_FLOWM_CCP.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr>
          <td colspan="20">
            <!--^====== NOT HOE CONTRIBUTION OR NOT HOE SOON TO EXPIRE ======^-->
            <div class="Not-FM" *ngIf="ALL_FLOWM_CCP.length===0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Not-Contribution.png" alt="">
              </div>
              <div class="Text-Not-FM">
                ¡{{GetGreeting()}}, {{NameUser()}}, no tiene ningúna HOE {{!IsExpired ? 'contribuida pendiente':'próxima a expirar'}}!
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>

</div>

<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)=" ToggleModalHelp(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
        <div class="Content-Top">
          <h2>Iconografía</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">
                Icono
              </div>
              <div class="Description">
                Descripción
              </div>
            </div>
            <div *ngFor="let icon of Icons;let i = index" class="grid-column-2">
              <div class="Icon-container">
                <div class="Icon-Status Status{{i+1}}">
                  <div><i class="fa-solid {{Icons[i].Icon}}"></i></div>
                </div>
              </div>
              <div class="Description">
                {{icon.Description}}
              </div>
            </div>

          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)=" ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== LOADER =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
